import axios from "axios";
import { API_BASE_URL } from "../../../constants/apiConstants";
import { enqueueSnackbar } from "notistack";

export async function sendEmailActivateAccount(emailAccount, token) {
  const url = `${API_BASE_URL}Medicos/EnvioMailActivaCuenta`;
  try {
    const response = await axios.post(url, { email: emailAccount, token }, {
      headers: {
        accept: "text/plain",
        "Content-Type": "application/json",
      },
    });
    const {data} = response
    enqueueSnackbar(response.data.successMessage, {variant:"success"})
    return data;
  } catch (error) {
    console.error("Error en Activar cuenta:", error);
    enqueueSnackbar(error.message, {variant:"error"})
    return error
  }
}
